import { useState, useCallback } from 'react';

/**
 * Custom hook to manage error notifications
 * Replaces alert() calls with elegant ErrorNotification component
 *
 * Usage:
 * const { showError, ErrorNotificationComponent } = useErrorNotification();
 *
 * // Show error
 * showError('Your error message here');
 *
 * // Render in component
 * return (
 *   <div>
 *     {ErrorNotificationComponent}
 *     {// rest of your component}
 *   </div>
 * );
 */
export const useErrorNotification = () => {
  const [error, setError] = useState(null);

  const showError = useCallback((message) => {
    setError(message);
  }, []);

  const hideError = useCallback(() => {
    setError(null);
  }, []);

  return {
    showError,
    hideError,
    error,
    isVisible: error !== null
  };
};
